module.exports = __webpack_public_path__ + "static/img/per6.678b5e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per6.jpg
// module id = qgMq
// module chunks = 41